export default "$ yarn add babel-polyfill\n// OR\n$ npm install babel-polyfill --save\n";